// extracted by mini-css-extract-plugin
export default {"root":"BannerPagination_root__N73lm","arrowButton":"BannerPagination_arrowButton__1uBVs"};